import * as React from 'react'
import { PencilSquareIcon } from '@heroicons/react/24/outline'

import { cn } from '@/lib/utils'
import { Button } from '../primitives/Button'
import { Card, CardContent, CardHeader, CardTitle } from '../primitives/Card'

interface EditableCardProps {
  title: string
  icon?: React.ReactNode
  onEdit?: () => void
  children: React.ReactNode
  className?: string
}

export function EditableCard({
  title,
  icon,
  onEdit,
  children,
  className,
}: EditableCardProps) {
  return (
    <Card
      className={cn(
        'flex flex-col gap-4 rounded-xl bg-[#FAFAFA] p-4 shadow-sm',
        className
      )}
    >
      <CardHeader className="flex flex-row items-start gap-4 p-0">
        <CardTitle className="flex flex-1 items-center justify-between">
          <h3 className="flex items-center gap-4 font-geist text-base font-medium leading-6 text-[#262626]">
            {icon && <span className="h-4 w-4">{icon}</span>}
            {title}
          </h3>
          {onEdit && (
            <Button
              className="h-6 w-6 rounded"
              onClick={onEdit}
              size="icon"
              title={`Editar ${title.toLowerCase()}`}
              variant="ghost"
            >
              <PencilSquareIcon className="h-4 w-4 stroke-[1.33px] text-[#262626]" />
            </Button>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-1 p-0">{children}</CardContent>
    </Card>
  )
}
